import { render, staticRenderFns } from "./function-settings.vue?vue&type=template&id=7f645ede&scoped=true&lang=pug&"
import script from "./function-settings.vue?vue&type=script&lang=js&"
export * from "./function-settings.vue?vue&type=script&lang=js&"
import style0 from "./function-settings.vue?vue&type=style&index=0&id=7f645ede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f645ede",
  null
  
)

export default component.exports